import { TreeNode } from '@direct-frontend/components';

export function countCheckedNodesWithoutCheckedChildren(
    nodeMap: Map<string, TreeNode>,
    value: [string, boolean][]
): number {
    // Create a map for quick lookup of checked status
    const checkedStatusMap = new Map<string, boolean>();
    value.forEach(([id, checked]) => {
        checkedStatusMap.set(id, checked);
    });

    // Count checked nodes without any checked immediate children
    let count = 0;

    value.forEach(([id, checked]) => {
        // Skip unchecked nodes
        if (!checked) return;

        const node = nodeMap.get(id);

        // If node doesn't exist or has no children, it can't have checked children
        if (!node || !node.children || node.children.length === 0) {
            count++;
            return;
        }

        // Check if any immediate children are checked
        const hasCheckedChild = node.children.some(child => checkedStatusMap.get(child.id) === true);

        // If no immediate children are checked, increment the counter
        if (!hasCheckedChild) {
            count++;
        }
    });

    return count;
}
